import React from 'react';
import { Link } from 'gatsby';
import classNames from 'classnames';

import { WidthContainer, PaddingContainer, QuoteWithPhoto } from '@components';
import FCQCaseStudyBg from '@static/images/figures/fcq-case-study.webp';
import MichalPhoto from '@images/staff/ux_michal.webp';
import { PageUrls } from '@utils/constants/PageUrls';

import * as styles from './FCQCaseStudy.module.scss';

export const FCQCaseStudy: React.FC = () => {
	return (
		<PaddingContainer className="gray-bg">
			<WidthContainer>
				<div
					className={classNames(
						styles.container,
						'd-flex flex-column flex-xl-row'
					)}
				>
					<div className={styles.typographies}>
						<p className="font-size-small-title mb-3 font-600">
							Finance capital platform
						</p>
						<p className="font-size-sm mb-4">
							The platform designed to manage all savings and allowing to trade
							them for tokens on only one platform, which works in favor of the
							cryptocurrency world and the real estate market.
						</p>
						<Link
							to={PageUrls.FCQ_CASE_STUDY}
							className={classNames(styles.link, 'font-size-14')}
						>
							See full case study
						</Link>
					</div>
					<div
						className={classNames(
							styles.imageHolder,
							'd-flex justify-content-center align-items-start'
						)}
					>
						<img src={FCQCaseStudyBg} alt="FCQ case study" />
					</div>
				</div>
				<div className="mt-5">
					<QuoteWithPhoto
						image={MichalPhoto}
						author="Michał, UX/UI Designer"
						photoOnLeft
					>
						<p className="font-size-sm">
							We managed to deliver a safe and intuitive platform, not to forget
							innovative. The user pays with USDT and buys shares in real estate
							in exchange for tokens.
							<span className="orange-font font-600 mx-1">
								All transactions are based on blockchain
							</span>
							(distributed information system).
						</p>
					</QuoteWithPhoto>
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
